import type {
  CurbsideSetting,
  ReservationMode,
  ReservationModeLabels,
} from '@iheartjane/types';
import compact from 'lodash-es/compact';

import type { ScheduleType, StoreSchedule } from '@jane/shared-ecomm/util';

const defaultInStorePickupText = 'In-store pickup';
const defaultCurbsidePickupText = 'Curbside pickup';

export const filterOrderingSchedules = (
  schedules: Array<StoreSchedule | null>,
  store: {
    curbside_pickup_setting: CurbsideSetting | null;
  } | null
): StoreSchedule[] => {
  const curbsideMandatory = store?.curbside_pickup_setting === 'mandatory';
  const curbsideDisabled = store?.curbside_pickup_setting === 'not_allowed';

  const shouldExcludeSchedule = (schedule: StoreSchedule | null) => {
    return (
      (schedule?.type === 'pickup' && curbsideMandatory) ||
      (schedule?.type === 'curbside' && curbsideDisabled)
    );
  };

  return compact(
    schedules.filter((schedule) => !shouldExcludeSchedule(schedule))
  );
};

export const fulfillmentLabel = (
  store: {
    curbside_pickup_setting?: CurbsideSetting | null;
    reservation_mode_labels?: ReservationModeLabels;
  } | null,
  fulfillmentMode: ScheduleType | 'kiosk'
) => {
  const modeLabel = reservationModeLabel(store, fulfillmentMode);
  if (store?.curbside_pickup_setting === 'allowed' && modeLabel === 'pickup')
    return defaultInStorePickupText;
  else if (modeLabel === 'curbside') return defaultCurbsidePickupText;
  return modeLabel;
};

export const reservationModeLabel = (
  store: { reservation_mode_labels?: ReservationModeLabels } | null | undefined,
  reservationMode: ReservationMode | ScheduleType
) => {
  if (reservationMode === 'retail' || !store) return reservationMode;

  const { reservation_mode_labels } = store;

  return (
    (reservation_mode_labels &&
      reservation_mode_labels[
        reservationMode as keyof typeof reservation_mode_labels
      ]) ||
    reservationMode
  );
};
